import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  totalCount,
  pageSize = 20,
  showInfo = true 
}) => {
  if (totalPages <= 1) return null;

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalCount);

  // Sahifa raqamlarini hisoblash
  const getPageNumbers = () => {
    const pages = [];
    const showPages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(showPages / 2));
    let endPage = Math.min(totalPages, startPage + showPages - 1);
    
    if (endPage - startPage + 1 < showPages) {
      startPage = Math.max(1, endPage - showPages + 1);
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="pagination-wrapper">
      {showInfo && (
        <div className="pagination-info">
          <span>
            Ko'rsatilmoqda: <strong>{startIndex + 1}-{endIndex}</strong> / {totalCount} ta
          </span>
        </div>
      )}
      
      <div className="pagination">
        <button 
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          title="Birinchi sahifa"
        >
          <ChevronsLeft size={16} />
        </button>
        <button 
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          title="Oldingi sahifa"
        >
          <ChevronLeft size={16} />
        </button>
        
        {getPageNumbers().map(page => (
          <button
            key={page}
            className={`btn btn-sm ${currentPage === page ? 'btn-primary' : 'btn-secondary'}`}
            onClick={() => onPageChange(page)}
          >
            {page}
          </button>
        ))}
        
        <button 
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          title="Keyingi sahifa"
        >
          <ChevronRight size={16} />
        </button>
        <button 
          className="btn btn-sm btn-secondary"
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          title="Oxirgi sahifa"
        >
          <ChevronsRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
